<template>
  <div id="page-wrapper" v-if="loggedIn" class="hidden-xs">
    <div class="container">
      <div class="row page-section">
        <div class="col-md-4 col-xs-6">
          <div class="prepaid-form text-center">
            <p class="title ptb-70">{{responseMessage.responseDescription}}</p>
            <router-link :to="{name:'Dashboard'}">
              <ActionButton title="Go to Home" />
            </router-link>
          </div>
        </div>
        <div class="col-md-8 text-center">
          <div class="prepaid-form">
            <img
              src="/static/images/svgs/PaymentFailure.svg"
              alt="Payment Failed"
              class="status-image"
            />
            <h4 class="status-text">Payment Failed</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ActionButton from "@/components/ActionButton/index";
export default {
  name: "RechargeFailed",
  props: ["responseMessage"],
  computed: {
    ...mapGetters(["loggedIn", "selecetedPlan"])
  },

  components: { ActionButton },
  methods: {
    proceedToHome() {
      this.$router.push({ name: this.category });
    }
  },
  mounted() {
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "TRANSACTED",
      propertyName: "TRANSACTION_TYPE",
      propertyValue: "BILL_PAYMENT"
    });
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "TRANSACTED",
      propertyName: "AMOUNT",
      propertyValue: this.selectedPlan
    });
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "TRANSACTED",
      propertyName: "RESULT",
      propertyValue: "DECLINED"
    });
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "TRANSACTED",
      propertyName: "MESSAGE",
      propertyValue: this.responseMessage.responseDescription
    });
  }
};
</script>
<style lang="scss" scoped>
.title {
  font-size: 20px;
  line-height: 27px;
  color: #4d4d4d;
}
.status-image {
  height: 171px;
  width: auto;
  margin-top: 30px;
  margin-bottom: 30px;
}
h4.status-text {
  font-size: 25px;
  line-height: 39px;
  letter-spacing: 0.39px;
  color: #4d4d4d;
}
</style>



// WEBPACK FOOTER //
// src/components/EplNewPaymentFailure.vue